import * as API from './api'
import * as Types from './Types'

export function tryCreateInformationItem(token, communityId, data) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_INFORMATION_ITEM
    })

    API.createInformationItem(token, communityId, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_INFORMATION_ITEM_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.CREATE_INFORMATION_ITEM_FAILED,
          payload: status
        })
      })
  }
}

export function tryUpdateInformationItem(
  token,
  communityId,
  informationItemId,
  postData
) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_INFORMATION_ITEM
    })

    API.updateInformationItem(token, communityId, informationItemId, postData)
      .then(response => {
        dispatch({
          type: Types.UPDATE_INFORMATION_ITEM_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        let status = 500

        if (error.response && error.response.status) {
          status = error.response.status
        }

        dispatch({
          type: Types.UPDATE_INFORMATION_ITEM_FAILED,
          payload: status
        })
      })
  }
}

export function tryDeleteInformationItem(
  token,
  communityId,
  informationItemId
) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_INFORMATION_ITEM
    })

    API.deleteInformationItem(token, communityId, informationItemId)
      .then(() => {
        dispatch({
          type: Types.DELETE_INFORMATION_ITEM_SUCCESS,
          payload: informationItemId
        })
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_INFORMATION_ITEM_FAILED
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/InformationItems.js